import { Pipe, PipeTransform } from '@angular/core';
import { RiskService } from '../services/risk.service';

@Pipe({ name: 'riskProbability' })
export class RiskProbabilityPipe implements PipeTransform {

	constructor(private riskService: RiskService) {	}

	transform(value: any) {
		const probability = this.riskService.riskProbabilities.find(x => value >= x.min && value <= x.max);

		if (probability) {
			return probability.label;
		}

		return value;
	}
}
